// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"230":"4049ac8b6a0da1ff9b36","883":"9b4f56ced30efc2f35da"}[chunkId] + ".js";
};